import { __awaiter, __generator, __values } from "tslib";
import fs from 'fs';
import path from 'path';
import dedent from 'dedent';
import { getState } from '../utils';
import appRoot from 'app-root-path';
export var addComponent = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    var srcDir, components, components_1, components_1_1, component, newDir, indexFile, indexPath, fileContents, lastExportFromIndex, lastExportFromNewLineIndex;
    var e_1, _a;
    var _b;
    return __generator(this, function (_c) {
        if (typeof name !== 'string' || !/^[A-Z][a-z]+(?:[A-Z][a-z]+)*$/.test(name)) {
            throw new Error('Name must be a PascalCase string');
        }
        if (!getState().hasAddedReact) {
            throw new Error('Need to add React first');
        }
        srcDir = path.join(appRoot.path, 'src');
        components = fs.readdirSync(srcDir, {
            withFileTypes: true
        });
        try {
            for (components_1 = __values(components), components_1_1 = components_1.next(); !components_1_1.done; components_1_1 = components_1.next()) {
                component = components_1_1.value;
                if (component.name === name) {
                    throw new Error((component.isDirectory() ? 'Component' : 'File') + " with that name already exists");
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (components_1_1 && !components_1_1.done && (_a = components_1.return)) _a.call(components_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        newDir = path.join(srcDir, name);
        fs.mkdirSync(newDir);
        fs.writeFileSync(path.join(newDir, 'index.tsx'), dedent("\n    import React from 'react'\n\n    const " + name + " = ({ text }: { text: string }): JSX.Element => <h1>{text}</h1>\n\n    export default " + name + "\n    ") + '\n');
        fs.writeFileSync(path.join(newDir, 'index.test.tsx'), dedent("\n    import React from 'react'\n    import { render, waitFor, screen } from '@testing-library/react'\n    import " + name + " from '.'\n\n    it('should render correctly', async () => {\n      render(<" + name + " text=\"hello there\" />)\n      await waitFor(() => screen.getByRole('heading'))\n      expect(screen.getByRole('heading')).toHaveTextContent('hello there')\n    })\n    ") + '\n');
        fs.writeFileSync(path.join(newDir, 'index.stories.tsx'), dedent("\n    import React from 'react'\n    import { withKnobs, text } from '@storybook/addon-knobs'\n    import " + name + " from '.'\n\n    export default {\n      component: " + name + ",\n      title: '" + name + "',\n      decorators: [withKnobs]\n    }\n\n    export const Default = (): JSX.Element => {\n      const textValue = text('Name', 'Example Text')\n      return <" + name + " text={textValue} />\n    }\n    ") + '\n');
        indexFile = (_b = components.find(function (_a) {
            var name = _a.name;
            return name.startsWith('index.ts');
        })) === null || _b === void 0 ? void 0 : _b.name;
        if (indexFile) {
            indexPath = path.join(srcDir, indexFile);
            fileContents = fs.readFileSync(indexPath, 'utf8');
            lastExportFromIndex = fileContents.lastIndexOf('export * from');
            lastExportFromNewLineIndex = lastExportFromIndex +
                fileContents.slice(lastExportFromIndex).indexOf('\n');
            fs.writeFileSync(indexPath, fileContents.slice(0, lastExportFromNewLineIndex) + "\nexport * from './" + name + "'" + fileContents.slice(lastExportFromNewLineIndex));
        }
        return [2];
    });
}); };
//# sourceMappingURL=index.js.map